import React, {useState} from 'react';
import moment from "moment";
import {getAssetPath} from "../../../../utils/get-asset-path.js";
import {
    FaArrowLeft,
    FaEnvelope,
    FaEnvelopeOpenText,
    FaRegStar, FaStar,
    FaTrash
} from "react-icons/fa";
import {BsEnvelopeCheckFill} from "react-icons/bs";
import "moment/locale/pt-br.js"
import UserMessagesReceiver from "./user-messages-receiver.jsx";
import ModalAttaches from "../../../../components/modal/modal-attaches.jsx";

const API_URL = import.meta.env.VITE_API_URL;

const UserMessagesDetails = ({selected, messages, returnToDefault, updateStatus, viewSent, toggleFavorite}) => {
    const message = messages.find(item => item.id === selected)
    const {id, title, userCreatedName, userCreatedNameWar, status, content, contentOld, attaches, createdAt, favorite} = message;

    const [show, setShow] = useState(false);
    const [attachSelected, setAttachSelected] = useState(false);
    const [userReceiverOpen, setUserReceiverOpen] = useState(false);

    const diff = moment().diff(moment(createdAt), 'days');
    const dateFormatted = moment(createdAt).format("DD/MM/YY, HH:mm");

    const openModal = async (attach) => {
        setShow(true);
        setAttachSelected(attach);
    }

    return (
        <>
            <div className="flex flex-col h-full gap-2">
                <div className="shrink-0">
                    <h2 className="font-bold flex gap-1 items-center">
                        <span className="cursor-pointer me-4" onClick={returnToDefault}>
                            <FaArrowLeft size={16}/>
                        </span>
                        {title}
                    </h2>
                    <div className="flex justify-between ml-9">
                        <h3>De: {userCreatedName} {userCreatedNameWar ? "(" + userCreatedNameWar + ")" : ""}</h3>

                        <div className="flex justify-end items-center gap-3">
                            {dateFormatted} {diff > 1 ? `(há ${diff} dias)` : ""}

                            {
                                !viewSent && !favorite &&
                                <span className="cursor-pointer" title="Favoritar mensagem" onClick={() => toggleFavorite(true, [id])}>
                                    <FaRegStar />
                                </span>
                            }

                            {
                                !viewSent && favorite &&
                                <span className="cursor-pointer" title="Remover dos favoritos" onClick={() => toggleFavorite(false, [id])}>
                                    <FaStar color={"#ffca28"}/>
                                </span>
                            }

                            {
                                status === "NEW" &&
                                <span className="cursor-pointer" onClick={() => updateStatus("VIEWED", [id])} title="Marcar como lido">
                                    <BsEnvelopeCheckFill siesize={21} />
                                </span>
                            }

                            {
                                status === "VIEWED" &&
                                <span className="cursor-pointer" onClick={() => updateStatus("NEW", [id])} title="Marcar como não lido">
                                    <FaEnvelope size={15} />
                                </span>
                            }

                            {
                                viewSent &&
                                <span className="cursor-pointer" title="Exibir status" onClick={() => setUserReceiverOpen(true)}>
                                    <FaEnvelopeOpenText />
                                </span>
                            }

                            <span className="cursor-pointer" onClick={() => updateStatus("EXCLUDED", message.userNotifications ?? [id])} title="Excluir mensagem">
                                <FaTrash />
                            </span>
                        </div>
                    </div>
                </div>

                <div className="whitespace-break-spaces border border-[var(--default-border)] rounded-md bg-[#fdfdfd] py-4 px-9 grow overflow-auto">
                    {contentOld ? contentOld : <div dangerouslySetInnerHTML={{__html: content}}/>}

                    {
                        !!attaches.length &&
                        <>
                            {!!content && <hr className={"opacity-30 !mt-4"}/>}

                            <label>Anexos: </label>
                            <div className="grid grid-cols-12 gap-2 border border-[var(--default-border)] p-4 rounded-md">
                                {
                                    attaches.map((attach) => {
                                        const {attachId, extension, name} = attach;

                                        return (
                                            <div className={"col-span-3"} key={attachId} onClick={() => openModal(attach)}>
                                                <div className="flex flex-col items-center justify-center">
                                                    {
                                                        !extension.includes("pdf") ?
                                                            <img className="cursor-pointer max-h-[300px] max-w-[95%] rounded-sm"
                                                                 src={`${API_URL}/attach/` + attachId}
                                                                 alt={attachId}/>
                                                            :
                                                            <img className="cursor-pointer max-h-[300px] max-w-[95%] rounded-sm"
                                                                 src={getAssetPath("img/file-types/pdf.png")}
                                                                 alt={attachId}/>
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </>
                    }
                </div>

                {
                    message?.dtValidate &&
                    <i className="mt-1 text-end">
                        Data de expiração: {moment(message.dtValidate).format('DD/MM/YYYY HH:mm')}
                    </i>
                }
            </div>

            <ModalAttaches
                open={show}
                setOpen={setShow}
                file={attachSelected}
            />

            <UserMessagesReceiver
                open={userReceiverOpen}
                setOpen={setUserReceiverOpen}
                message={message}
            />
        </>
    );
};

export default UserMessagesDetails;